import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationService } from '@services/organization';
import { toast } from 'react-toastify';

export const useBulkToggleInvoicingPaused = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'bulkToggleInvoicingPaused'],
    mutationFn: async ({ ids, paused }: { ids: string[]; paused: boolean }) =>
      organizationService.setInvoicingPausedBulk(ids, paused),
    onSuccess: (count, { paused }) => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      const suffix = count === 1 ? 'organization' : 'organizations';
      toast.success(
        paused
          ? `Invoicing paused for ${count} ${suffix}`
          : `Invoicing resumed for ${count} ${suffix}`,
      );
    },
    onError: (error: any) => {
      console.error('Bulk toggle invoicing paused error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.message ||
        error?.toString() ||
        'Failed to update invoicing status';
      toast.error(errorMessage);
    },
  });
};

export default useBulkToggleInvoicingPaused;
